import { render, staticRenderFns } from "./HelpEmissionsFactors.vue?vue&type=template&id=b622a354"
import script from "./HelpEmissionsFactors.vue?vue&type=script&lang=js"
export * from "./HelpEmissionsFactors.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports